import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { TProductWithRelation } from '@/types/product-type';
import { Package } from 'lucide-react';
import { Control } from 'react-hook-form';
import { ProductVariantRow } from './bulk-receive-variant-row';

interface BulkReceiveProductCardProps {
  productData: TProductWithRelation;
  control: Control<Record<string, number | undefined>>;
  isSubmitting: boolean;
  getFutureStock: (variant: TProductWithRelation['productVariants'][0]) => number;
}

export function BulkReceiveProductCard({
  productData,
  control,
  isSubmitting,
  getFutureStock,
}: BulkReceiveProductCardProps) {
  return (
    <Card className="min-w-0">
      <CardHeader className="pb-2 px-3 sm:px-6">
        <div className="flex items-center gap-2">
          <div className="w-7 h-7 sm:w-8 sm:h-8 rounded-lg bg-muted flex items-center justify-center overflow-hidden flex-shrink-0">
            {productData.product.imageUrl ? (
              <img
                src={productData.product.imageUrl}
                alt={productData.product.name}
                className="w-full h-full object-cover"
              />
            ) : (
              <Package className="h-3.5 w-3.5 sm:h-4 sm:w-4 text-muted-foreground" />
            )}
          </div>
          <div className="min-w-0 flex flex-1 gap-1 items-center">
            <CardTitle className="text-sm truncate">{productData.product.name}</CardTitle>
            <CardDescription className="text-xs break-words sm:break-normal">
              • {productData.productVariants.length} variant(s)
            </CardDescription>
          </div>
        </div>
      </CardHeader>
      <CardContent className="pt-0 px-0 sm:px-6 min-w-0">
        <div className="min-w-0 w-full">
          {productData.productVariants.map((variant, index) => (
            <ProductVariantRow
              key={variant.id}
              variant={variant}
              control={control}
              isSubmitting={isSubmitting}
              futureStock={getFutureStock(variant)}
              isLast={index === productData.productVariants.length - 1}
            />
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
